import React, { useEffect, useState, useContext, useCallback } from "react";
import "./Trainer.scss";
import {
  Form,
  ButtonGroup,
  ToggleButton,
  Button,
  Dropdown
} from "react-bootstrap";
import Countdown from "react-countdown";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

import { POKTOOLS_API_URL } from "../PoktoolsVariables";
import { LoadingContext } from "../../../api/loading/LoadingContext";
import { AspectRatio, assets, nFormatter } from "../../../api/ReplayVariables";
import { PoktoolsContext } from "../poktoolsContext";
import TrainerTable from "./TrainerTable";
import { UserContext } from "../../../api/user/userContext";
import OptionsDialog from "../../../replayer/OptionsDialog";

const Loading = require("react-loading-animation");

function Trainer({ history, match, onShowLogin }) {
  const { user } = useContext(UserContext);
  const { poktoolsState, dispatchPoktoolsState } = useContext(PoktoolsContext);
  const [data, setData] = useState(null);
  const { loading, dispatchLoading } = useContext(LoadingContext);
  const [questions, setQuestions] = useState(0);
  const [correct, setCorrect] = useState(0);
  const [incorrect, setIncorrect] = useState(0);
  const { t } = useTranslation();

  const showError = useCallback(
    (message) => {
      toast.error(t("poktools.error") + " : " + message, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: 0
      });
    },
    [t]
  );

  const [realTableRatio, setRealTableRatio] = useState(1);
  const [answered, setAnswered] = useState(false);

  const [startTime, setStartTime] = useState(null);

  let _bg = localStorage.getItem("poktools.trainer.background");
  if (assets["background" + _bg] === undefined) {
    console.log("no bridge");
    _bg = "Dark2";
  }
  const [background, setBackground] = useState(_bg);

  let _t = localStorage.getItem("poktools.trainer.table");
  if (assets["table" + _t] === undefined) {
      _t = 6;
  } else {
    if (isNaN(_t)) {
      _t = 6;
    } else {
      _t = parseInt(_t);
    }
  }
  const [table, setTable] = useState(_t);

  //---------
  //SPEED
  //---------
  const [speed, setSpeed] = useState(0);

  const doSetSpeed = (_sp) => {
    setStartTime(Date.now());
    console.log("speed", speed);
    setSpeed(_sp);
  };

  const [showOptions, setShowOptions] = useState(false);
  const onBackgroundChange = (_background) => {
    setBackground(_background);
    localStorage.setItem("poktools.trainer.background", _background);
  };

  const onTableChange = (_table) => {
    setTable(_table);
    localStorage.setItem("poktools.trainer.table", _table);
  };

  const fetchData = useCallback(
    (_speed = speed) => {
      setAnswered(false);
      //FETCH HAND DETAILS
      dispatchLoading({ type: "update", payload: 10 });
      axios({
        method: "post",
        headers: {
          "X-USER-POKTOOLS": poktoolsState.xUserPoktools,
          "X-PARTNER-POKTOOLS": poktoolsState.xPartnerPoktools,
          "X-PASS-POKTOOLS": poktoolsState.xPassPoktools,
          "x-xeester-licence": poktoolsState.xXeesterLicence,
          Accept: "*/*",
          "content-type": "application/x-www-form-urlencoded"
        },
        params: {
          game: match.params.game,
          situation: match.params.situation,
          level: match.params.level
        },
        mode: "cors",
        url: POKTOOLS_API_URL + "trainer"
      })
        .then((resp) => {
          if (resp.data.errorCode) {
            dispatchLoading({ type: "update", payload: 100 });
            showError("FETCH");
          } else {
            //console.info("trainer resp", resp.data);
            setData((da) => resp.data);
            dispatchLoading({ type: "update", payload: 100 });
            setStartTime(Date.now());
            setSpeed((s) => _speed);
          }
        })
        .catch((err) => {
          console.error("fetch problem", err);
          dispatchLoading({ type: "update", payload: 100 });
          showError("FETCH");
        });
    },
    [
      speed,
      dispatchLoading,
      poktoolsState.xUserPoktools,
      poktoolsState.xPartnerPoktools,
      poktoolsState.xPassPoktools,
      poktoolsState.xXeesterLicence,
      match.params.game,
      match.params.situation,
      match.params.level,
      showError
    ]
  );

  const pushorcall = () => {
    let _answer = match.params.situation === "openpush" ? "PUSH" : "CALL";
    answer(_answer);
  };
  const fold = () => {
    answer("FOLD");
  };

  const showLogin = useCallback(() => {
    onShowLogin();
  }, [onShowLogin]);

  const answer = useCallback(
    (_answer) => {
      setStartTime(null);
      setQuestions((q) => questions + 1);
      setAnswered(true);
      if (_answer === data.trainerResult.response) {
        setCorrect((c) => correct + 1);
        console.log("right answer");
        toast.success(
          t("poktools.trainer.right_answer").replace(
            "[EV]",
            nFormatter(data.trainerResult.ev)
          ),
          {
            position: "bottom-right",
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: 0
          }
        );
      } else {
        console.log("wrong  answer");
        setIncorrect((i) => incorrect + 1);
        toast.error(
          t("poktools.trainer.wrong_answer").replace(
            "[EV]",
            nFormatter(data.trainerResult.ev)
          ),
          {
            position: "bottom-right",
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: 0
          }
        );
      }
    },
    [correct, data, incorrect, questions, t]
  );

  useEffect(() => {
    //console.log("effect, token", poktoolsState);

    let urls = {
      home: window.poktoolsLastUrls.home,
      trainer: window.poktoolsLastUrls.trainer,
      fastpok: window.poktoolsLastUrls.fastpok,
      rp: window.poktoolsLastUrls.rp
    };
    urls.trainer = document.location.href.substring(
      document.location.href.indexOf("/app/poktools/")+ 14
    );
    //console.log("changed url:" + urls.trainer);
    window.poktoolsLastUrls = urls;

    dispatchLoading({ type: "update", payload: 10 });

    fetchData();

    return () => {
      //console.log("trainer done");
    };
  }, [
    dispatchLoading,
    dispatchPoktoolsState,
    showLogin,
    fetchData,
    poktoolsState.xPassPoktools,
    poktoolsState.xUserPoktools,
    user.crypt,
    user.error,
    speed
  ]);

  return (
    <>
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover={false}
      />
      <div
        className={
          "trainer-loading-container" +
          (loading.progress === 100 ? " done" : "")
        }
      >
        <div>
          <Loading></Loading>
        </div>
      </div>
      <div id="bg">
        <img src={assets["background" + background]} alt=""></img>
      </div>
      <table id="trainer" className="flex-grow-1 h-100">
        <tbody>
          <tr>
            <td className="poktools-form">
              <div
                className="back"
                onClick={() => {
                  history.push("/app/poktools/home");
                }}
              >
                &lt; <span className="back-text">{t("poktools.back")}</span>
              </div>
              <div className="poktools-form-content">
                <Form
                  style={{
                    fontSize:
                      Math.round(
                        AspectRatio.refFontSize * realTableRatio * 1.2
                      ) + "px",
                    lineHeight:
                      Math.round(AspectRatio.refFontSize * realTableRatio * 2) +
                      "px"
                  }}
                >
                  <span className="form-label">
                    {t("poktools.trainer.level.name")}
                  </span>
                  <ButtonGroup toggle>
                    <ToggleButton
                      type="radio"
                      variant="secondary"
                      name="radio"
                      value={1}
                      checked={match.params.level === "1"}
                    >
                      <Link
                        to={
                          "/app/poktools/trainer/1/" +
                          match.params.game +
                          "/" +
                          match.params.situation
                        }
                        className="owner-details-container d-flex flex-row"
                      >
                        {t("poktools.trainer.level.1")}
                      </Link>
                    </ToggleButton>
                    <ToggleButton
                      type="radio"
                      variant="secondary"
                      name="radio"
                      value={2}
                      checked={match.params.level === "2"}
                    >
                      <Link
                        to={
                          "/app/poktools/trainer/2/" +
                          match.params.game +
                          "/" +
                          match.params.situation
                        }
                        className="owner-details-container d-flex flex-row"
                      >
                        {t("poktools.trainer.level.2")}
                      </Link>
                    </ToggleButton>
                    <ToggleButton
                      type="radio"
                      variant="secondary"
                      name="radio"
                      value={3}
                      checked={match.params.level === "3"}
                    >
                      <Link
                        to={
                          "/app/poktools/trainer/3/" +
                          match.params.game +
                          "/" +
                          match.params.situation
                        }
                        className="owner-details-container d-flex flex-row"
                      >
                        {t("poktools.trainer.level.3")}
                      </Link>
                    </ToggleButton>
                  </ButtonGroup>
                  <span className="form-label">
                    {t("poktools.trainer.game.name")}
                  </span>
                  <ButtonGroup toggle>
                    <ToggleButton
                      type="radio"
                      variant="secondary"
                      name="radio"
                      value="exp"
                      checked={match.params.game === "exp"}
                    >
                      <Link
                        to={
                          "/app/poktools/trainer/" +
                          match.params.level +
                          "/exp/" +
                          match.params.situation
                        }
                        className="owner-details-container d-flex flex-row"
                      >
                        Expresso
                      </Link>
                    </ToggleButton>
                    <ToggleButton
                      type="radio"
                      variant="secondary"
                      name="radio"
                      value="6max"
                      checked={match.params.game === "6max"}
                    >
                      <Link
                        to={
                          "/app/poktools/trainer/" +
                          match.params.level +
                          "/6max/" +
                          match.params.situation
                        }
                        className="owner-details-container d-flex flex-row"
                      >
                        6 max
                      </Link>
                    </ToggleButton>
                  </ButtonGroup>
                  <span className="form-label">
                    {t("poktools.trainer.situation.name")}
                  </span>
                  <ButtonGroup toggle>
                    <ToggleButton
                      type="radio"
                      variant="secondary"
                      name="radio"
                      value="openpush"
                      checked={match.params.situation === "openpush"}
                    >
                      <Link
                        to={
                          "/app/poktools/trainer/" +
                          match.params.level +
                          "/" +
                          match.params.game +
                          "/openpush"
                        }
                        className="owner-details-container d-flex flex-row"
                      >
                        Open Push
                      </Link>
                    </ToggleButton>
                    <ToggleButton
                      type="radio"
                      variant="secondary"
                      name="radio"
                      value="callpush"
                      checked={match.params.situation === "callpush"}
                    >
                      <Link
                        to={
                          "/app/poktools/trainer/" +
                          match.params.level +
                          "/" +
                          match.params.game +
                          "/callpush"
                        }
                        className="owner-details-container d-flex flex-row"
                      >
                        Call vs Push
                      </Link>
                    </ToggleButton>
                  </ButtonGroup>
                </Form>
              </div>
            </td>
          </tr>
          <tr>
            <td className="table-cell">
              <div className="table-zone">
                <TrainerTable
                  data={data}
                  match={match}
                  table={assets["table" + table]}
                  onRealTableRatio={(ratio) => setRealTableRatio(ratio)}
                ></TrainerTable>
                {questions > 0 ? (
                  <Form className="score">
                    <ButtonGroup toggle>
                      <Button
                        className={
                          correct <= questions / 2
                            ? "bad"
                            : correct <= (questions * 3) / 4
                            ? "medium"
                            : "good"
                        }
                      >
                        {Math.round((correct * 100) / questions)}%
                      </Button>
                    </ButtonGroup>
                  </Form>
                ) : (
                  <></>
                )}
              </div>
            </td>
          </tr>
          <tr>
            <td className="poktools-action">
              <Dropdown className="speed">
                <Dropdown.Toggle id="dropdown-custom-components">
                  {t("poktools.trainer.speed." + speed)}
                </Dropdown.Toggle>
                {speed > 0 && startTime !== null ? (
                  <Countdown
                    date={startTime + speed * 1000}
                    onComplete={() => answer("NONE")}
                    renderer={({ seconds }) => {
                      return <Button className="count-down">{seconds}</Button>;
                    }}
                  ></Countdown>
                ) : (
                  <></>
                )}

                <Dropdown.Menu>
                  <Dropdown.Item
                    eventKey="0"
                    active={speed === 0}
                    onClick={() => doSetSpeed(0)}
                  >
                    {t("poktools.trainer.speed.0")}
                  </Dropdown.Item>
                  <Dropdown.Item
                    eventKey="10"
                    active={speed === 10}
                    onClick={() => doSetSpeed(10)}
                  >
                    {t("poktools.trainer.speed.10")}
                  </Dropdown.Item>
                  <Dropdown.Item
                    eventKey="5"
                    active={speed === 5}
                    onClick={() => doSetSpeed(5)}
                  >
                    {t("poktools.trainer.speed.5")}
                  </Dropdown.Item>
                  <Dropdown.Item
                    eventKey="2"
                    active={speed === 2}
                    onClick={() => doSetSpeed(2)}
                  >
                    {t("poktools.trainer.speed.2")}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              {!answered ? (
                <Form>
                  <ButtonGroup toggle>
                    <span className="form-label">&nbsp;</span>
                    <Button
                      className="fold"
                      disabled={loading.progress < 100}
                      onClick={fold}
                    >
                      FOLD
                    </Button>
                    <span className="form-label">
                      {t("poktools.trainer.situation.or")}
                    </span>
                    <Button
                      className="pushorcall"
                      disabled={loading.progress < 100}
                      onClick={pushorcall}
                    >
                      {match.params.situation === "openpush" ? "PUSH" : "CALL"}
                    </Button>
                    <span className="form-label">?</span>
                  </ButtonGroup>
                </Form>
              ) : (
                <Form>
                  <ButtonGroup toggle>
                    <Button className="next" onClick={() => fetchData(speed)}>
                      {t("poktools.trainer.next")}
                    </Button>
                  </ButtonGroup>
                </Form>
              )}
              <Form className="options">
                <ButtonGroup toggle>
                  <Button
                    className="options"
                    onClick={() => {
                      setShowOptions(true);
                    }}
                  >
                    {t("poktools.trainer.options")}
                  </Button>
                </ButtonGroup>
              </Form>
            </td>
          </tr>
        </tbody>
      </table>
      <OptionsDialog
        show={showOptions}
        selectedBackground={background}
        selectedTable={table}
        handleClose={() => {
          setShowOptions(false);
        }}
        onBackgroundChange={onBackgroundChange}
        onTableChange={onTableChange}
        ratio={realTableRatio}
      ></OptionsDialog>
    </>
  );
}
export default Trainer;
